export default __webpack_public_path__ + "static/media/confetti.982d2d54.gif";